import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { supportingText } from './styles';
export const SupportingText = ({ children }) => {
    return (_jsx("div", Object.assign({ css: (theme) => supportingText(theme.checkbox && theme) }, { children: children }), void 0));
};
//# sourceMappingURL=SupportingText.js.map
